export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">
          移动入口
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-lg mx-auto">
          国产91视频移动端适配方案，随时随地畅享久久视频、芒果视频等在线视频网站资源
        </p>
        <div className="bg-background-100 rounded-2xl border border-background-200/70 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-10">
            <div className="flex-1 text-center lg:text-left">
              <div className="flex items-center justify-center lg:justify-start gap-3 mb-6">
                <div className="w-12 h-12 rounded-2xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-smartphone-line text-2xl text-primary-600"></i>
                </div>
                <span className="text-lg font-bold text-foreground-800 font-heading">移动端访问指南</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                国产91视频已针对移动端进行全面优化，您可以通过手机浏览器直接访问本站，享受与桌面端一致的视频播放器在线看视频体验。久久视频、芒果视频、97视频、丝瓜视频等在线视频网站资源均已适配移动端浏览。无需下载任何应用，打开浏览器输入网址即可畅享全部视频资源导航服务。
              </p>
              <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
                <div className="flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-lg border border-background-200/60">
                  <i className="ri-chrome-line text-accent-500 text-lg"></i>
                  <span className="text-sm text-foreground-600 whitespace-nowrap">Chrome 浏览器</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-lg border border-background-200/60">
                  <i className="ri-safari-line text-accent-500 text-lg"></i>
                  <span className="text-sm text-foreground-600 whitespace-nowrap">Safari 浏览器</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-lg border border-background-200/60">
                  <i className="ri-android-line text-accent-500 text-lg"></i>
                  <span className="text-sm text-foreground-600 whitespace-nowrap">Android 浏览器</span>
                </div>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-48 h-80 bg-background-200 rounded-3xl border-4 border-background-300 overflow-hidden shadow-lg">
                <div className="h-10 bg-background-300 flex items-center justify-center">
                  <span className="text-xs text-foreground-500">国产91视频</span>
                </div>
                <div className="p-4 space-y-3">
                  <div className="h-3 bg-background-400 rounded w-3/4"></div>
                  <div className="h-3 bg-background-400 rounded w-1/2"></div>
                  <div className="h-20 bg-accent-100 rounded-lg mt-3"></div>
                  <div className="h-20 bg-primary-100 rounded-lg"></div>
                  <div className="h-20 bg-secondary-100 rounded-lg"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}